// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fnch","footer":"styles_footer__1qkaA","passCodeTooltip":"styles_passCodeTooltip__34pU_"};